import { useEffect, useRef } from 'react';
import {
  POLICY_CHECK_MAX_COUNT,
  POLICY_CHECK_INTERVAL,
  PolicyStatus,
} from 'constants/policy';
import { getPolicyById } from 'services';
import { getComparePolicyRoute, getPolicyProgressCount } from 'helpers';
import { IAppState, IPolicy } from 'types';
import history from 'helpers/history';
import { MARKET_SCAN_COMPARE_ROUTE } from 'constants/routes';
import { useDispatch, useSelector } from 'react-redux';
import { GetUserPolicies } from 'actions';

const notifyByInformation = (policy) => {
  if (policy.status === PolicyStatus.MARKET_SCAN_DRAFT) {
    // When in MS route, its showing the "Upload" spinner screen
    // so we go straight to MS form page
    if (location.pathname === MARKET_SCAN_COMPARE_ROUTE) {
      history.push(getComparePolicyRoute(policy.id));
    }
  }
};

const usePolicyNotification = () => {
  const dispatch = useDispatch();
  const {
    policies: { policies },
  } = useSelector(R.identity) as IAppState;

  // TODO: Use firebase for this
  // Keep track of notifications so we do not keep creating multiple intervals for the same policy
  const notifications = useRef({});

  const removeNotification = (id, intervalId) => {
    notifications.current = R.dissoc(id, notifications.current);
    clearInterval(intervalId);
  };

  const addNotification = (id, intervalId) => {
    notifications.current = R.assoc(id, intervalId, notifications.current);
  };

  useEffect(() => {
    if (policies.length > 0) {
      policies.forEach((policy: IPolicy) => {
        const { id, sk, processed, status, uploadedAt } = policy;
        const currentCount = getPolicyProgressCount(uploadedAt);
        const policyInterval = notifications.current[id];
        if (
          !processed &&
          !policyInterval &&
          status !== PolicyStatus.FINISH_SETUP &&
          currentCount < POLICY_CHECK_MAX_COUNT
        ) {
          const interval = setInterval(async () => {
            const count = getPolicyProgressCount(uploadedAt);
            if (count >= POLICY_CHECK_MAX_COUNT) {
              removeNotification(id, interval);
            } else {
              const { data } = await getPolicyById(id, sk);
              if (data.Count > 0) {
                const p = data.Items[0];
                if (p.processed) {
                  removeNotification(id, interval);
                  dispatch(GetUserPolicies(sk));
                  notifyByInformation(p);
                }
              } else {
                // Theres something wrong when policy cant be found so stopping it early
                removeNotification(id, interval);
              }
            }
          }, POLICY_CHECK_INTERVAL);

          if (!policyInterval) {
            addNotification(id, interval);
          }
        }
      });
    }
  }, [policies]);
};

export default usePolicyNotification;
